function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M162 81.5C162 36.489 125.735 0 81 0S0 36.489 0 81.5 36.265 163 81 163s81-36.489 81-81.5z",
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M68.812 128.812a3.653 3.653 0 01-3.535-2.707 3.66 3.66 0 01-.07-1.582v-.022l5.6-30.751H49.124a3.187 3.187 0 01-2.478-5.192L90.31 34.582a3.676 3.676 0 016.534 2.731c0 .06-.016.118-.026.178l-5.62 30.759h21.677a3.186 3.186 0 012.478 5.192l-43.668 53.976a3.675 3.675 0 01-2.873 1.394z",
  fill: "#fff"
});

function SvgVault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 163,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.554ac14c.svg";
export { ForwardRef as ReactComponent };